type Municipality = {
    id: number;
    name?: string;
    key?: string;
};

export default {
    recordRepresentation: (record: Municipality) =>
        record?.name || record?.key || `Municipality #${record?.id ?? ''}`,
};
